import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';

import { DialogService } from 'primeng/dynamicdialog';

import { HTTPService, DataService, DateService, FormatService, HelperService } from 'app/services';
import { find } from 'lodash';

import { config, } from 'app/constants';

@Component({
  selector: 'app-catalog-pricing-list',
  templateUrl: './catalog-pricing-list.component.html',
  styleUrls: ['./catalog-pricing-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [DialogService],
})
export class PartsPricingCatalogComponent implements OnInit {
  @Input() columns = [];
  @Input() pricingMatrix: any = {};
  @Input() type = 'part';

  @Output() itemsChecked = new EventEmitter();
  noRecFound = false;
  selectAllItems = false;
  records = [];
  cols: any[] = [];
  config = config;
  totalRecords: number;
  loading: boolean = true;
  tableConfig = {
    offset: 1,
    limit: 10,
  };
  isLoading: boolean = false;
  tableCheckState: number = 0;
  itemList: any[] = [];
  isFirstTimeLoad: boolean = true;
  pages = [];
  constructor(
    public dateService: DateService,
    private httpService: HTTPService,
    public helperService: HelperService,
    private formatService: FormatService,
    private dataService: DataService
  ) { }

  async ngOnInit() {
    this.getCatalogMatrixPricing();
  }


  handleSelectAllItems() {
    // if (!this.pricingMatrix?.updateSyncItems) {
    this.selectAllItems = !this.selectAllItems;
    this.records.map((data) => {
      if (this.selectAllItems) {
        data.selectedItems = true;
      } else {
        if (!data?.isSelected) {
          data.selectedItems = false;
        }
      }
      this.updateItemList(data);
    });
    // }
    this.emitSelectedItems();
  }

  pushToList(data: any, event?) {
    if (event && !data?.isSelected) {
      if (this.listHasValue(data)) {
        const index = this.findItemIndex(data._id);
        this.selectAllItems = false;
        data.selectedItems = false;
        if (data?.isSelected) {
          data.selectedItems = true;
        }
        this.itemList[index] = data;
      } else {
        data.selectedItems = true;
        this.updateItemList(data);
      }

    } else {
      if (data?.isSelected) {
        data.selectedItems = true;
        const index = this.findItemIndex(data._id);
        if (index !== -1) {
          this.itemList[index] = data;
        } else {
          this.itemList.push(data);
        }
      }
    }

    this.checkAllItemsSelected();
    this.emitSelectedItems();
  }

  updateItemList(data: any): void {
    const index = this.findItemIndex(data._id);
    if (index !== -1) {
      this.itemList[index] = data;
    } else {
      this.itemList.push(data);
    }
  }

  listHasValue(obj: any) {
    let hasValue = false;
    for (let i = 0; i < this.itemList.length; i++) {
      if (this.itemList[i].selectedItems && this.itemList[i]._id === obj._id) {
        hasValue = true;
        return hasValue;
      }
    }

    if (!hasValue) {
      return false;
    }
  }

  getCatalogMatrixPricing(
    limit = 10,
    type = this.type,
    page = this.tableConfig.offset
  ) {
    const query: any = {
      limit: limit,
      page: page,
      type: type,
      id: this.pricingMatrix._id,
      isSyncItems: this.pricingMatrix?.updateSyncItems ? true : false
    };

    this.httpService
      .getCatalogMatrixPricing(query)
      .then(
        (response) => {
          const records = response[0].records;
          records.forEach(item => {
            this.updateShopDetails(item);
          });
          this.records = this.formatService.formatCatalogPriceMatrix(records);
          this.totalRecords = response[0].metaData.totalRecords;

          if (!this.pages.includes(page) && !this.pricingMatrix.updateSyncItems) {
            this.records.forEach(item => {
              item.selectedItems = true;
              this.updateItemList(item);
            });
            this.pages.push(page);
          }

          this.records.forEach(item => {
            if (this.listHasValue(item)) {
              item.selectedItems = true;
            }
            this.updateItemList(item);
          });
          if (this.pricingMatrix?.updateSyncItems) {
            this.syncPricingMatrixItems();
          }
          this.emitSelectedItems();
          this.checkAllItemsSelected();
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      )
      .finally(() => {
        this.isFirstTimeLoad = false;
        this.loading = false;
      });
  }

  updateShopDetails(item: any): void {
    const shopDetail = find(item?.shopDetails, { shopId: this.dataService.currentShopId });
    if (shopDetail) {
      item.shopDetails = shopDetail;
    }
  }

  syncPricingMatrixItems(): void {
    this.records.forEach(data => {
      if (data?.isSelected || data?.selectedItems) {
        this.pushToList(data);
      } else {
        data.selectedItems = false;
        this.itemList.push(data);
      }
    });
  }

  emitSelectedItems(): void {
    const selectedItems = {
      type: this.type,
      list: this.itemList,
      totalRecords: this.totalRecords
    };
    this.itemsChecked.emit(selectedItems);
  }

  checkAllItemsSelected(): void {
    this.selectAllItems = this.records.every(item => item.selectedItems || item.isSelected);
  }

  // retain value after page switching
  getValueFromSelectedItemList(id) {
    if (this.itemList.length) {
      let found = false;
      for (let i = 0; i < this.itemList.length; i++) {
        if (this.itemList[i]._id == id) {
          if (this.itemList[i]?.selectedItems || this.itemList[i]?.isSelected) {
            found = true;
          } else {
            found = false;
          }
          break;
        }
      }
      return found;
    }

    return false;
  }

  paginate({ page }: any) {
    this.tableConfig.offset = page + 1;
    this.selectAllItems = false;
    this.getCatalogMatrixPricing();
  }

  changeRedColor(field, rowData) {
    if (field === 'updatedPrice') {
      if (rowData['updatedPrice'] < rowData['price']) {
        return 'font-red';
      }
    }
    return '';
  }

  findItemIndex(id: string): number {
    return this.itemList.findIndex(obj => obj._id === id);
  }

}
